import { ControlledDatePicker, SectionTitle } from 'modules/shared/components';
import { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

const CURRENT_ROUND_KEY = 'contract';

export default function ContractRound({ interviewData, readOnly, onApprove }) {
  const methods = useForm({
    mode: 'onChange',
    defaultValues: {
      joiningDate: null,
    },
  });

  useEffect(() => {
    if (interviewData?.induction?.joiningDate) {
      methods.reset({
        joiningDate: interviewData.induction.joiningDate,
      });
    }
  }, [interviewData.induction.joiningDate, methods]);

  const hasContract = Array.isArray(interviewData?.contract) && interviewData.contract.length === 1;

  const { watch, trigger } = methods;

  const joiningDate = watch('joiningDate');

  const handleSendContract = async () => {
    if (hasContract || readOnly) return;

    const isValid = await trigger('joiningDate', { shouldFocus: true });
    if (!isValid) return;

    onApprove?.({
      action: 'submit',
      currentRoundKey: CURRENT_ROUND_KEY,
      induction: { joiningDate },
      contract: [
        {
          status: 'sent',
          id: null,
          name: null,
          url: null,
          sendDate: new Date().toISOString(),
          acceptedDate: null,
          rejectedDate: null,
        },
      ],
    });
  };

  const isDateChanged = joiningDate !== interviewData?.induction?.joiningDate;

  const handleUpdateJoiningDate = async () => {
    if (!joiningDate || !isDateChanged || readOnly) return;

    const isValid = await trigger('joiningDate', { shouldFocus: true });
    if (!isValid) return;

    onApprove?.({
      action: 'submit',
      currentRoundKey: CURRENT_ROUND_KEY,
      induction: { joiningDate },
    });
  };

  const disableButton = readOnly || !joiningDate || hasContract;

  return (
    <FormProvider {...methods}>
      <form className='column gap-3'>
        <SectionTitle title='CONTRACT' />

        <div className='row row--between'>
          <label>Employee Date of Joining</label>

          <div className='row gap-3'>
            <ControlledDatePicker
              id='joining-date'
              name='joiningDate'
              disabled={readOnly}
              rules={{ required: 'Joining date is required' }}
              disablePast
              sx={{ width: 200, alignSelf: 'flex-end' }}
            />
            {!readOnly && hasContract && (
              <button
                type='button'
                className='btn cta-outlined-btn'
                disabled={!isDateChanged}
                onClick={handleUpdateJoiningDate}
              >
                Update
              </button>
            )}
          </div>
        </div>

        <div className='row row--between'>
          <label>Employment contract / Appointment letter</label>
          <div className='text--secondary'>
            <button
              type='button'
              className='btn cta-outlined-btn'
              onClick={handleSendContract}
              disabled={disableButton}
            >
              Generate & Send
            </button>
          </div>
        </div>
      </form>
    </FormProvider>
  );
}
